module.exports = __webpack_public_path__ + "static/images/resources-empty.f813cbba8531b4f14bed9e89918957a0.svg";